import Logo from "../assets/crowdslogo.svg?react";
import { Box } from "@chakra-ui/react";

export function CrowdsLogo({ w = "160px", h = "40px", color = "#FE6ABE" }) {
    return (
        <Box w={w} h={h} color={color} >
            <Logo width="100%" height="100%" />
        </Box>
    );
}